module.exports = ".a.download-zip-link{\n  display: none;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consultar-asignaciones/consultar-asignaciones.component.css
// module id = ./src/app/consultar-asignaciones/consultar-asignaciones.component.css
// module chunks = main